import { useRef } from 'react';
import { calculateRideMetrics, formatDuration, type Ride } from '../../domain/ride';
import type { RenderPresetId } from '../../domain/render-preset';
import { recordingDeviceLabel } from '../../../../renderer/src/recording-device';
import { RideName } from '../../components/RideName';
import type { DraftControls } from '../../studio/StudioSettings';
import { AspectRatioControl } from './AspectRatioControl';

export function RidePanel({ ride, draft, update, onFormat, onFileSelected, importBusy, importError, importMessage, onRename, showFormat = true }: DraftControls & {
  showFormat?: boolean; ride: Ride; onFormat: (format: RenderPresetId) => void; onFileSelected: (file: File) => void; importBusy: boolean; importError: string; importMessage?: string; onRename?: (title: string) => boolean;
}) {
  const fileInput = useRef<HTMLInputElement>(null);
  const metrics = ride.metrics ?? calculateRideMetrics(ride.points, ride.timerDurationSeconds);
  return <section className="source-controls">
    <div className="stage-heading"><span className="eyebrow">{ride.source.toUpperCase()} activity</span>
      {ride.sourceFileName && <p className="studio-source">{ride.sourceFileName}</p>}
      {ride.recordingDevice && <p>{recordingDeviceLabel(ride.recordingDevice)}</p>}
      <RideName title={draft.title} onRename={title => { const saved = update(current => ({ ...current, title })); return onRename?.(title) !== false && saved; }} />
      <p>{metrics.distanceKilometers.toFixed(1)} km · {formatDuration(metrics.durationSeconds)}</p>
    </div>
    <div className="studio-source-actions">
      <button type="button" className="trace-panel-action" disabled={importBusy} onClick={() => fileInput.current?.click()}>Open trace file</button>
      <input ref={fileInput} hidden type="file" accept=".fit,.gpx,.tcx,.json" disabled={importBusy} onChange={event => {
        const file = event.currentTarget.files?.[0]; event.currentTarget.value = ''; if (file) onFileSelected(file);
      }} />
    </div>
    {importBusy && <p role="status">Reading recorded trace…</p>}
    {importError && <p role="alert">{importError}</p>}
    {!importBusy && !importError && importMessage && <p role="status">{importMessage}</p>}
    {showFormat && <AspectRatioControl value={draft.preset} onChange={onFormat} />}
  </section>;
}
